@if (item) {
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white">
      <h6 class="mb-0">
        <i class="bi bi-device-hdd me-2"></i>
        SN: {{ item.serialnumber }}
      </h6>
    </div>
    <div class="card-body">
      <div class="row">
        <!-- Order Information -->
        <div class="col-lg-3 mb-3">
          <div class="border rounded internal-card h-100 d-flex flex-column">
            <h6 class="text-primary pb-1">
              <i class="bi bi-file-earmark-text me-1"></i>Commessa
            </h6>
            <div class="flex-grow-1 scrollable-content">
              @if (item.orders.length === 0) {
                <div class="text-muted text-center">
                  <small>Nessuna commessa</small>
                </div>
              }
              @for (order of item.orders; track order) {
                <div class="order-item">
                  <div class="row mt-0 pt-0">
                    <button
                      class="btn btn-link mb-0 pb-0"
                      style="text-align: left;"
                      (click)="goTo(order.path, order.idcommessaw)"
                      >
                      <span
                        >N.{{ order.progressive }} creato il
                        {{ order.creation_date | date : "dd/MM/yyyy" }}</span
                        >
                      </button>
                    </div>
                    <div class="row">
                      <span> {{ order.register.denominazione }}</span>
                    </div>
                    @if (order.serial_match_type) {
                      <div class="row">
                        <small class="text-muted">
                          @if (order.serial_match_type === 'uscita') {
                            {{ 'SUB_TEST.ROW_TEST.SERIAL_MATCH_OUT' | translate }}
                            @if (order.serialnumber_in) {
                              <span> (ingresso: {{ order.serialnumber_in }})</span>
                            }
                          } @else if (order.serial_match_type === 'ingresso_uscita') {
                            {{ 'SUB_TEST.ROW_TEST.SERIAL_MATCH_IN' | translate }} / {{ 'SUB_TEST.ROW_TEST.SERIAL_MATCH_OUT' | translate }}
                          } @else {
                            {{ 'SUB_TEST.ROW_TEST.SERIAL_MATCH_IN' | translate }}
                          }
                        </small>
                      </div>
                    }
                    <div
                      class="row"
                      style="padding-top: 0.2rem; padding-left: 0.7rem"
                      >
                      <span
                        class="my-badge"
                        style="background-color: cadetblue;"
                        >
                        {{ order.order_status?.name }}
                      </span>
                    </div>
                    <hr />
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- System Information -->
          <div class="col-lg-3 mb-3">
            <div class="border rounded p-3 internal-card h-100 d-flex flex-column">
              <h6 class="text-success pb-1">
                <i class="bi bi-cpu me-1"></i>Impianto
              </h6>
              <div class="flex-grow-1 scrollable-content">
                @if (item.systems.length === 0) {
                  <div class="text-muted text-center">
                    <small>Nessun impianto</small>
                  </div>
                }
                @for (system of item.systems; track system) {
                  <div class="system-item">
                    <div class="row" style="overflow: hidden; text-overflow: ellipsis;">
                      <button
                        class="btn btn-link mb-0 pb-0"
                        style="text-align: left;"
                        (click)="goTo(system.path, system.idsystem)"
                        >
                        <p matTooltip="{{ system.system_description }}" class="mb-0">
                          {{ system.system_name }}
                        </p>
                      </button>
                    </div>
                    <div class="row">
                      <span
                        >Data:
                        {{ system.created_at | date : "dd/MM/yyyy" }}</span
                        >
                      </div>
                      <div
                        class="row"
                        style="padding-top: 0.2rem; padding-left: 0.7rem"
                        >
                        <span
                          class="my-badge"
                          [style.background-color]="'#' + system.system_status.color"
                          >
                          {{ system.system_status.name }}
                        </span>
                      </div>
                      <hr />
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- Ticket Information -->
            <div class="col-lg-3 mb-3">
              <div class="border rounded p-3 internal-card h-100 d-flex flex-column">
                <h6 class="text-warning pb-1">
                  <i class="bi bi-ticket-detailed me-1"></i>Ticket
                </h6>
                <div class="flex-grow-1 scrollable-content">
                  @if (item.tickets.length === 0) {
                    <div class="text-muted text-center">
                      <small>Nessun ticket</small>
                    </div>
                  }
                  @for (ticket of item.tickets; track ticket) {
                    <div class="ticket-item">
                      <div class="row">
                        <button
                          class="btn btn-link mb-0 pb-0"
                          style="text-align: left"
                          (click)="goTo(ticket.path, ticket.idticket)"
                          >
                          <span>
                            <span class="id-ticket">Id: </span>
                            {{ ticket.idticket }} -
                            {{ ticket.ticket_date | date : "dd/MM/yyyy" }}
                          </span>
                        </button>
                      </div>
                      <div
                        class="row"
                        style="padding-top: 0.2rem; padding-left: 0.7rem"
                        >
                        <span
                          class="my-badge"
                          [style.background-color]="ticket.ticket_status.status.color"
                          >
                          {{ ticket.ticket_status.status.name }}
                        </span>
                      </div>
                      <hr />
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- RMA Information -->
            <div class="col-lg-3 mb-3">
              <div class="border rounded p-3 internal-card h-100 d-flex flex-column">
                <h6 class="text-danger pb-1">
                  <i class="bi bi-file-earmark-arrow-down me-1"></i>RMA
                </h6>
                <div class="flex-grow-1 scrollable-content">
                  @if (item.rma.length === 0) {
                    <div class="text-muted text-center">
                      <small>Nessun RMA</small>
                    </div>
                  }
                  @for (rma of item.rma; track rma) {
                    <div class="rma-item">
                      <div class="row">
                        <button
                          class="btn btn-link mb-0 pb-0"
                          style="text-align: left"
                          (click)="downloadRma(rma.src, rma.filename)"
                          >
                          <span>
                            <i class="bi bi-download me-1"></i>
                            {{ rma.filename }}
                          </span>
                        </button>
                      </div>
                      <div class="row">
                        <span>Data: {{ rma.created_at | date : "dd/MM/yyyy" }}</span>
                      </div>
                      @if (rma.costante_temp) {
                        <div class="row">
                          <span class="text-muted" style="font-size: 0.85rem">Rif: {{ rma.costante_temp }}</span>
                        </div>
                      }
                      <hr />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
